import React from "react";
import { Spin } from "antd";
import '@/components/less/loading.less'
//语言切换
import intl from "react-intl-universal";

function Loading() {
  return (
    <div className="loading">
      <Spin tip={intl.get("Loading_910b61fe-7e7f-2b70-a5ae-97e743818378")} size="large" />
    </div>
  );
}

export default Loading;
